<mat-progress-bar *ngIf="callInProgress" mode="indeterminate" class="w-100" color="warn"></mat-progress-bar>

<div class="d-flex flex-column w-100 h-100">
  <div *ngIf="isRouteLoading" class="d-flex w-100 h-100">
    <div class="d-flex flex-column m-auto">
      <div class="d-flex mx-auto" style="width: 36px; height: 36px;">
        <img class="mx-auto" src="https://storage.googleapis.com/ashgridx-application-artifacts/public/ashgridx-primary.svg" alt="AshgridX">
      </div>
      <span class="m-auto mat-headline-5 fw-bolder">AshGridX</span>
    </div>
  </div>

    <div *ngIf="!isRouteLoading" class="d-flex flex-column my-auto container px-3 py-4">
        <div class="d-flex flex-column w-100 mx-auto my-auto p-2 p-sm-3 px-md-5 py-md-5 rounded-3 rounded-sm-5 bg-white">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
